import { LabelDocumentTypeHandler, LabelDocumentHandler } from "features/label-editor/LabelDocumentHandler";
import { DocumentTypeHandler, WineMenuDocumentTypeHandler, LeafletDocumentTypeHandler, AperitifDocumentTypeHandler, DocumentHandler, WineMenuDocumentHandler, LeafletDocumentHandler, AperitifDocumentHandler } from "./DocumentHandler";
import { MenuDocument } from "./MenuDocumentModel";



export function createDocumentTypeHandler(type: MenuDocument['type']): DocumentTypeHandler {
    const cl = type === 'wine' ? WineMenuDocumentTypeHandler
    : type === 'leaflet' ? LeafletDocumentTypeHandler
    : type === 'label' ? LabelDocumentTypeHandler
    : type === 'aperitif' ? AperitifDocumentTypeHandler : null;
    if (!cl) throw new Error(`Incorrect document type ${type}`);
    return new cl(type);
}

export function createDocumentHandler(document: MenuDocument): DocumentHandler {
    const type = document.type;
    const cl = type === 'wine' ? WineMenuDocumentHandler
    : type === 'leaflet' ? LeafletDocumentHandler
    : type === 'label' ? LabelDocumentHandler
    : type === 'aperitif' ? AperitifDocumentHandler : null;
    if (!cl) throw new Error(`Incorrect document type ${type}`);
    return new cl(document);
}
